import { Injectable } from '@angular/core';
import { CaseSubmissionType } from '../enums/case-submission-type.enum';
import { ESubmissionDocumentType } from '../enums/e-submission-document-type.enum';
import { OfflineDocumentType } from '../enums/offline-document-type.enum';
import { OnlineDocumentType } from '../enums/online-document-type.enum';
/**
 * 處理檔案相關功能
 */
@Injectable({
  providedIn: 'root',
})
export class FileService {

  documentDescriptionMap: Record<CaseSubmissionType, Record<string, string>> = {
    [CaseSubmissionType.OnlineDealerWeb]: {
      [OnlineDocumentType.IdentityCardFront]: 'DealerWeb OCR Idcard-front',
      [OnlineDocumentType.IdentityCardBack]: 'DealerWeb OCR Idcard-back',
      [OnlineDocumentType.IncomeDocumentPaysip]: 'DealerWeb OCR Payslip File'
    },
    [CaseSubmissionType.Offline]: {
      [OfflineDocumentType.IdentityCardFront]: 'Paper OCR Idcard-front',
      [OfflineDocumentType.IdentityCardBack]: 'Paper OCR Idcard-back',
      [OfflineDocumentType.IncomeDocumentPaysip]: 'Paper OCR Payslip File'
    },
    [CaseSubmissionType.ESubmission]: {
      [ESubmissionDocumentType.IdentityCardFront]: 'E-submission OCR Idcard-front',
      [ESubmissionDocumentType.IdentityCardBack]: 'E-submission OCR Idcard-back',
      [ESubmissionDocumentType.IncomeDocumentPaysip]: 'E-submission OCR Payslip File'
    },
    [CaseSubmissionType.Unknow]: {
      [ESubmissionDocumentType.IdentityCardFront]: '',
      [ESubmissionDocumentType.IdentityCardBack]: '',
      [ESubmissionDocumentType.IncomeDocumentPaysip]: ''
    }
  };

  constructor() { }

  /**
 * 產生預設特定種類的檔案描述
 * 僅處理IdentityCardFront/IdentityCardBack/IncomeDocumentPaysip
 * @param documentType 
 * @returns 
 */
  generateDefaultDocumentTypeDescription(documentType: string, caseSubmissionType: CaseSubmissionType) {
    const mapForSubmission = this.documentDescriptionMap[caseSubmissionType];
    if (!mapForSubmission) return '';
    return mapForSubmission[documentType] ?? '';
  }
  
  /**
   * 檢查OCR檔案類型
   * @param fileType 
   * @returns 
   */
  isOCRDocumentType(fileType: string, caseSubmissionType: CaseSubmissionType) {

    if(caseSubmissionType === CaseSubmissionType.OnlineDealerWeb)
    {
      const OCRDocumentType: OnlineDocumentType[] = [OnlineDocumentType.IdentityCardFront, OnlineDocumentType.IdentityCardBack, OnlineDocumentType.IncomeDocumentPaysip];
      return OCRDocumentType.includes(fileType as OnlineDocumentType);
    }

    if(caseSubmissionType === CaseSubmissionType.Offline)
    {
      const OCRDocumentType: OfflineDocumentType[] = [OfflineDocumentType.IdentityCardFront, OfflineDocumentType.IdentityCardBack, OfflineDocumentType.IncomeDocumentPaysip];
      return OCRDocumentType.includes(fileType as OfflineDocumentType);
    }

    if(caseSubmissionType === CaseSubmissionType.ESubmission)
    {
      const OCRDocumentType: ESubmissionDocumentType[] = [ESubmissionDocumentType.IdentityCardFront, ESubmissionDocumentType.IdentityCardBack, ESubmissionDocumentType.IncomeDocumentPaysip];
      return OCRDocumentType.includes(fileType as ESubmissionDocumentType);
    }

    return false;
  }

  /**
   * 檢查OCR副檔名
   * @param extension 
   * @returns 
   */
  isOCRDocumentExtension(extension: string) {
    const OCRLimitDocumentExtension = ['.JPG', '.JPEG', '.PDF', '.PNG'];
    return OCRLimitDocumentExtension.includes(extension.toUpperCase());
  }
}
